import { render, staticRenderFns } from "./dropdownMenu.vue?vue&type=template&id=406c90c4&scoped=true"
import script from "./dropdownMenu.vue?vue&type=script&lang=js"
export * from "./dropdownMenu.vue?vue&type=script&lang=js"
import style0 from "./dropdownMenu.vue?vue&type=style&index=0&id=406c90c4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406c90c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('406c90c4')) {
      api.createRecord('406c90c4', component.options)
    } else {
      api.reload('406c90c4', component.options)
    }
    module.hot.accept("./dropdownMenu.vue?vue&type=template&id=406c90c4&scoped=true", function () {
      api.rerender('406c90c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aiChat/components/dropdown/dropdownMenu.vue"
export default component.exports